/**
 * Figma: 선호하는 장르/악기 모달 (6415:78329, 6419:78522, 6419:78664, 6419:78723)
 * 프로필 수정 전용 — 회원가입 플로우와 분리
 */
export const PROFILE_MUSIC_GENRES = [
  '클래식',
  '재즈',
  '팝',
  '록/메탈',
  '힙합/R&B',
  '밴드',
  '전자음악',
  '발라드',
  'K-POP',
  '인디',
  '뮤지컬',
  '국악',
  'CCM/찬양',
  '영화음악/OST',
] as const;

export const PROFILE_MUSIC_INSTRUMENTS = [
  '피아노',
  '그랜드 피아노',
  '디지털 피아노',
  '신디사이저',
  '바이올린',
  '비올라',
  '첼로',
  '더블베이스',
  '기타',
  '베이스 기타',
  '플루트',
  '클라리넷',
  '색소폰',
  '트럼펫',
  '트럼본',
  '오보에',
  '드럼',
  '젬베',
  '퍼커션',
  '보컬',
  '랩/MC',
  '작곡/미디',
  '디제인(DJ)',
  '프로듀싱/믹싱',
] as const;

export const PROFILE_GENRE_INSTRUMENT_MAX = 3;
